import VideoRecorder from "./VideoRecorder.js"
import LevelBuilder from '../level/LevelBuilder.js';
import Player from "../entity/Player.js"
import SoundController from "./SoundController.js"
import CameraManager from "./CameraManager.js"
import { getElem, logEvent, pause} from "../utils/index.js";
import { sound } from "@pixi/sound";
import HTML_Tutorial from "../_html/HTML_Tutorial.js";

const tutorialOffset = -50;
class TutorialManager {
    constructor(config, app, engine, runner) {
        this.config = config;
        
        // Game state
        this.app = app;
        this.engine = engine;
        
        // Components
        this.levelBuilder = new LevelBuilder(this.app, this.engine, this.config);
        this.player = new Player(this.app, this.engine, this.config);
        this.html_Tutorial = new HTML_Tutorial();
        this.soundController = null;
        this.player.allowJump = false;
        this.player.allowMove = true;
        
        // Level data
        this.gameObjects = [];
        this.hazards = [];
        this.pickups = [];
        this.systems = [];
        
        this.collidedPickups = new Set();
        this.collidedSystems = new Set();

        this.OnEnd = null;
        this.isTutorial = false;

        getElem("tutorial-skip").addEventListener("pointerup", () => {
            logEvent("skip_tutorial_click");
            this.skip();
        })

        getElem("tutorial-playGame").addEventListener("pointerup", () => {
            logEvent("play_tutorial_click");
            this.iterateTutorial();
        })
        
        // Level tracking
        this.levelWidth = 0;
        this.tutorialIndex = 0;
    }

    async initialize(soundController, OnEnd) {
        try {
            this.isTutorial = true;
            this.OnEnd = OnEnd;
            this.soundController = soundController;
                    
            this.blackveil = new PIXI.Graphics();
            this.blackveil.beginFill(0x000000);
            this.blackveil.drawRect(0, 0, 3000, 3000);
            this.blackveil.endFill();
            this.blackveil.alpha = 0; // We'll bring this in later
            this.app.stage.addChild(this.blackveil);
            
            await this.tutorialStage(0, true);
            
            
            return true;
        } catch (error) {
            console.error('Error initializing game:', error);
            getElem('mic-error').style.display = 'block';
            return false;
        }
    }
    
    async tutorialStage(index, firstTime) {
        // Set global flag to prevent player movement
        window.gameStarted = false;
        
        if(index === 2) {
            const targetAlpha = 0.4;
            const fadeTicker = () => {
                if(this.blackveil.alpha < targetAlpha) {
                    this.blackveil.alpha += 0.02;
                } else {
                    this.blackveil.alpha = targetAlpha;
                    this.app.ticker.remove(fadeTicker);
                }
            }
            this.app.ticker.add(fadeTicker);
        }
        const levelData = this.levelBuilder.createTutorial(index);
        this.gameObjects = levelData.gameObjects;
        this.hazards = levelData.hazards;
        this.pickups = levelData.pickups;
        this.systems = levelData.systems;
        
        if(firstTime) {
            this.player.create(() => {
                setTimeout(() => {
                    this.gameStarted = true;
                    this.gameOver = false;
                    window.gameStarted = true;
                },500);
            }, tutorialOffset);
            this.app.ticker.add(this.gameLoop.bind(this));
        } else this.player.reset(tutorialOffset);

        if (this.player && this.player.body) {
            Matter.Body.setVelocity(this.player.body, { x: 0, y: 0 });
        }

        await this.html_Tutorial.activate(index);
    }
    
    readyPlayer() {

    }
    gameLoop() {
        // Update sound level
        const soundLevel = this.soundController.updateSoundLevel();
        
        // Handle player movement based on sound - only if game has started
        if (this.gameStarted && !this.gameOver) {
            this.player.handleMovement(soundLevel);
        } else {
            // Ensure player doesn't move during countdown
            if (this.player && this.player.body) {
                Matter.Body.setVelocity(this.player.body, { 
                    x: 0, 
                    y: this.player.body.velocity.y  // Keep gravity effect
                });
            }
        }
        
        // Update player
        this.player.update();
        
        if (this.gameStarted && !this.gameOver) {
            
            let firstFloater;
            this.gameObjects.forEach((gameobject, i) => {
                if(gameobject.body.label === "floater") {
                    if(!firstFloater) firstFloater = i;
                    const playerBottom = this.player.body.bounds.max.y;
                    const platformTop = gameobject.body.bounds.min.y;
   
                    if(Math.abs(playerBottom - platformTop) > 50) return;

                    if (playerBottom < platformTop + 15) {
                        // if(i === firstFloater) {
                        //     console.log(playerBottom, platformTop);
                        //     console.log("above!");
                        // }
                        gameobject.body.isSensor = false;
                    } else {
                        // if(i === firstFloater) {
                        //     console.log(playerBottom, platformTop)
                        //     console.log("below!");
                        // }

                        // Disable the collision for one-way platforms when jumping up
                        gameobject.body.isSensor = true;
                    }
                }
            })

            for (const pickup of this.pickups) {
                const pairs = Matter.Query.collides(this.player.body, [pickup.body]);

                if (!this.collidedPickups.has(pickup.body.id) && pairs.length > 0) {
                    if (this.tutorialIndex === 0 || this.tutorialIndex === 1) {
                        this.iterateTutorial();
                    }
                    this.collidedPickups.add(pickup.body.id);
                    pickup.destroy();
                    this.player.spawnScoreEff("+5");
                    break;
                }
            }
            for (const system of this.systems) {
                const pairs = Matter.Query.collides(this.player.body, [system.body]);
                if (!this.collidedSystems.has(system.body.id) && pairs.length > 0) {
                    this.collidedSystems.add(system.body.id);
                    switch(system.name) {
                        case("killWallTrig"):
                            let curStage = this.tutorialIndex;
                            setTimeout(() => {
                                if(curStage !== this.tutorialIndex) return;
                                this.tutorialStage(this.tutorialIndex);
                            }, 1500)
                            break;
                    }
                }
            }
        }

        // Check if player fell off screen
        if (this.isTutorial && this.gameStarted && !this.gameOver && this.player.isOffScreen()) {
            this.cleanupLevel();
            this.tutorialStage(this.tutorialIndex);
        }
    }

    iterateTutorial() {
        this.html_Tutorial.deactivate(this.tutorialIndex);
        if(this.tutorialIndex < this.levelBuilder.tutorialLength() - 1) {
            setTimeout(() => {
                this.cleanupLevel();
                this.tutorialIndex += 1;
                this.tutorialStage(this.tutorialIndex);
                if(this.tutorialIndex === 1) {
                    this.player.allowJump = true;
                    this.player.allowMove = false;
                }

                if(this.tutorialIndex === 2) {
                    this.player.allowJump = true;
                    this.player.allowMove = true;
                }
            }, 800);
        } else {
            this.html_Tutorial.hide();
            this.isTutorial = false;
            setTimeout(() => {
                this.player.allowJump = false;
                this.player.allowMove = false;
                this.OnEnd();
                this.cleanup();
            }, 800);
        }
    }

    skip() {
        this.html_Tutorial.hide();
        this.player.allowJump = false;
        this.player.allowMove = false;
        setTimeout(() => {
            this.OnEnd();
            this.cleanup();
        }, 1000);
    }


    cleanupLevel() {
        // Clean up level
        if (this.levelBuilder) {
            this.levelBuilder.cleanupLevel(this.gameObjects, this.hazards, this.pickups);
            this.gameObjects = [];
            this.hazards = [];
            this.pickups = [];
            this.systems = [];
        }
    }

    cleanup() {
        this.blackveil.destroy();
        this.collidedPickups.clear();
        this.collidedSystems.clear();
        // Stop the game loop
        if (this.app && this.app.ticker) {
            this.app.ticker.remove(this.gameLoop.bind(this));
        }
        
        if (this.player) this.player.cleanup();
        this.cleanupLevel();
    }
}  

export default TutorialManager;


class Instructions {
    
}